export const isSkVariant = (): boolean => {
    if (typeof window === 'undefined') return false
    return window.location.hostname.startsWith('view.')
}
